import { useCountdown } from "@/hooks/useCountdown";

const pad = (n) => String(n).padStart(2, "0");

const Countdown = ({ testid = "hero-countdown-timer" }) => {
  const { days, hours, minutes, seconds, live } = useCountdown();

  if (live) {
    return (
      <div data-testid={testid} className="font-mono text-coral text-xs tracking-[0.35em] uppercase">
        The night is here
      </div>
    );
  }

  const cells = [
    [days, "Days"],
    [hours, "Hrs"],
    [minutes, "Min"],
    [seconds, "Sec"],
  ];

  return (
    <div data-testid={testid} className="flex items-start divide-x divide-bone/15">
      {cells.map(([val, label]) => (
        <div key={label} className="flex flex-col pr-5 pl-5 first:pl-0 sm:pr-7 sm:pl-7">
          <span className="font-display font-bold text-2xl sm:text-3xl text-bone tabular-nums leading-none">{pad(val)}</span>
          <span className="mt-2 font-mono text-[9px] uppercase tracking-[0.3em] text-ash">{label}</span>
        </div>
      ))}
    </div>
  );
};

export default Countdown;
